var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewOrv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 175.61 200.8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.91 87.38V200.8H33V91.87a51.2 51.2 0 0 1-14.09-4.49M154.61 57.3 97.31 0 84.19 13.14a51.2 51.2 0 0 1 6.32 13.56l6.9-6.9 64.4 64.4v103.4h-20.6v-79.3h-15.7a35.4 35.4 0 0 0-10.9-8.4 37.08 37.08 0 0 0-33.7 0 39.2 39.2 0 0 0-11 8.4h-15.8v92.4h11.6V120h9.7l1.7-2.3a25.5 25.5 0 0 1 40.8 0l1.7 2.3h9.7v80.8h46.3V78.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.71 84.2 7.67-7.67a35.1 35.1 0 0 1-15.57-4l-5.9 5.92V200.8h14l-.19-13.2ZM97.21 0 72.45 24.76a35 35 0 0 1 4.08 15.62L97.11 19.8l6.89 6.9a51.2 51.2 0 0 1 6.32-13.56ZM97.34 115.6a20.49 20.49 0 0 0-17.6 10.1h-7.9v63.7h10.3V136h4.4l1.2-3.4a10.09 10.09 0 0 1 19 0l1.2 3.4h4.4v53.4h10.5v-63.7h-7.9a20.49 20.49 0 0 0-17.6-10.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.94 160.3h15.1v9.3h-15.1zM86.54 144.6h22v9.3h-22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.29 35.27V22.12H35.27v13.15H22.12v12.02h13.15v13.14h12.02V47.29h13.14V35.27z",
  className: "new-orv_svg__highlight"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.28 12A29.28 29.28 0 1 1 12 41.28 29.31 29.31 0 0 1 41.28 12m0-12a41.28 41.28 0 1 0 41.28 41.28A41.28 41.28 0 0 0 41.28 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.01 91.87v-9.31l-5.62 5.62v7.46z"
})))));
export default SvgNewOrv;